
import { useEffect, useState } from 'react';
import { DriversTab } from './driversTab';
import { OrderTrackingTab } from './orderTrackingTab';
import { DownIcon, LinesSpinner } from '../../../icons';
import { cfmsCodesOrderTracking } from '../../../config/constants';

export const CarManagementTool = ({
  carInfo,
  driversList = [],
  deliveryInfo,
  deliveryInfoLoading,
  handleClickAction,
  hasOnlyDriversRole,
}) => {
  // const [tab, setTab] = useState(driversList?.length === 0 && "order-tracking")
  const [tab, setTab] = useState("order-tracking")
  const [feStep, setFeStep] = useState(cfmsCodesOrderTracking[carInfo?.orderLine?.code])

  useEffect(() => {
    if (carInfo?.quantity > 1 && (carInfo?.orderLine?.code === "" || carInfo?.orderLine?.code === null)) {
      setFeStep(4);
      return;
    } else if (deliveryInfo?.data?.currentlyScheduled) {
      setFeStep(8)
      return;
    } else if (!carInfo?.orderLine || !carInfo?.orderLine?.code) {
       if(carInfo?.isDeliveryEligible && !carInfo?.hasAssignedDriver) {
        setFeStep(6);
        return;
      } else if(carInfo?.isDeliveryEligible && carInfo?.hasAssignedDriver) {
        setFeStep(7);
        return;
      } else {
        setFeStep(9);
        return;
      }
    } else {
      setFeStep(cfmsCodesOrderTracking[carInfo?.orderLine?.code]);
    }
  }, [carInfo?.hasAssignedDriver, carInfo?.isDeliveryEligible, carInfo?.orderLine, carInfo?.orderLine?.code, carInfo?.quantity, deliveryInfo?.data?.currentlyScheduled]);

  // useEffect(() => {
  //   if(feStep === 9 && driversList?.length === 0) {
  //     setTab('order-tracking')
  //   } else if(feStep === 9 && driversList?.length > 0) {
  //     setTab('drivers')
  //   } else {
  //     setTab('order-tracking')
  //   }
  // }, [feStep, driversList])

  return (
    <>
      <div className='flex flex-col gap-2 lg:absolute 2xl:-right-40 xl:-right-44 lg:-right-60 lg:top-0 justify-start'>
        {((!!carInfo?.orderLine || (!!carInfo?.quantity && carInfo?.quantity > 1)) && feStep > 0 && feStep < 8) && <div className='relative  top-[26px] z-[9999] flex flex-row gap-[10px] items-center justify-center '>
          <div className='flex flex-row justify-center items-center gap-[10px] text-white text-xs bg-primary rounded-ss-xl rounded-ee-xl px-2 py-[6px]'>
            <LinesSpinner className='animate-spin' />
              Εξέλιξη παραγγελίας
          </div>
        </div>}
        <div className="p-5 bg-white/60 backdrop-blur-2xl flex flex-col justify-center rounded-[10px] max-lg:max-w-[335px] max-lg:min-w-[335px] lg:max-w-[305px] lg:min-w-[305px] max-h-[448px]">
          {/* {feStep > 1 && feStep < 6 && <div className='text-xs font-semibold border-primary border-2 rounded-full py-[6px] px-4 max-w-min fixed'>Νέο</div>} */}
          {<div className='flex flex-col items-start'>
            {/* {!hasOnlyDriversRole && ((driversList?.length > 0 && carInfo?.orderLine ) || !carInfo?.orderLine) ? <button  */}
            {!hasOnlyDriversRole && ((driversList?.length > 0 && carInfo?.orderLine ) || (carInfo?.orderLine && feStep > 5 ) || !carInfo?.orderLine) ? <button 
              className={`flex flex-row w-full justify-between`}
              onClick={()=>{setTab("order-tracking")}}
              >
              <p className='text-lg font-bold'>My Cars</p>
              {/* {((driversList?.length > 0 && carInfo?.orderLine ) || !carInfo?.orderLine)  && <div className='h-6 w-6 flex justify-center items-center rounded-full border-black border-[1px] bg-white'> */}
              {((driversList?.length > 0 && carInfo?.orderLine ) || (carInfo?.orderLine && feStep > 5 ) || !carInfo?.orderLine)  && <div className='h-6 w-6 flex justify-center items-center rounded-full border-black border-[1px] bg-white'>
                <DownIcon className={tab==='order-tracking' ?'rotate-180' : ''} />
              </div>}
            </button> : feStep !== 9 && <div className='h-3'/>}
          </div>}
          {tab === 'order-tracking' && <OrderTrackingTab
            carInfo={carInfo}
            deliveryInfo={deliveryInfo}
            deliveryInfoLoading={deliveryInfoLoading}
            stepC={feStep}
            driversList={driversList}
            />}
        </div>
        {/* {!hasOnlyDriversRole && ((driversList?.length > 0 && carInfo?.orderLine ) || !carInfo?.orderLine) && <div className="p-4 bg-white/60 backdrop-blur-2xl flex flex-col rounded-[10px] max-lg:max-w-[335px] max-lg:min-w-[335px] lg:max-w-[305px] lg:min-w-[305px] max-h-[448px] "> */}
        {!hasOnlyDriversRole && ((driversList?.length > 0 && carInfo?.orderLine ) || (carInfo?.orderLine && feStep > 8 ) || !carInfo?.orderLine) && 
          <div className="p-5 bg-white/60 backdrop-blur-2xl flex flex-col rounded-[10px] max-lg:max-w-[335px] max-lg:min-w-[335px] lg:max-w-[305px] lg:min-w-[305px] max-h-[448px] ">
            <div className='flex flex-col items-start'>
              <button
                className={`flex flex-row w-full justify-between`}
                onClick={()=>{setTab("drivers")}}
                >
                <p className='text-lg font-bold'>Οδηγοί</p>
                <div className='h-6 w-6 flex justify-center items-center rounded-full border-black border-[1px] bg-white'>
                  <DownIcon className={tab==='drivers' ? 'rotate-180' : ''} />
                </div>
              </button>
            </div>
            {tab === 'drivers' && <DriversTab
              driversList={driversList}
              carInfo={carInfo}
              hasOnlyDriversRole={hasOnlyDriversRole}
              handleClickAction={handleClickAction}
              />}
          </div>
        }
      </div>
    </>
  );
};
